export enum ButtonType {
  facebook = 'facebook',
  primary = 'primary',
  rounded = 'rounded',
  secondary = 'secondary',
  tertiary = 'tertiary',
  textLink = 'textLink',
}

export enum ButtonSize {
  large = 'large',
  medium = 'medium',
  mediumSquare = 'mediumSquare',
  smallMedium = 'smallMedium',
  small = 'small',
  wide = 'wide',
}
